exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vc-checkerboard{position:absolute;top:0;right:0;bottom:0;left:0;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-534b5e18","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-color/src/components/common/Checkboard.vue
// module id = 1128
// module chunks = 0